import { render, staticRenderFns } from "./AddExperiment.vue?vue&type=template&id=22873453&scoped=true"
import script from "./AddExperiment.vue?vue&type=script&lang=js"
export * from "./AddExperiment.vue?vue&type=script&lang=js"
import style0 from "./AddExperiment.vue?vue&type=style&index=0&id=22873453&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22873453",
  null
  
)

export default component.exports